<template>
    <div >
        <div class="wrapper">
            <div class="title">Brrr..It's chilly out here 🤐</div>
            <div>We are not accepting registrations at the moment. Hoping to see you soon!</div>
        </div>
        <Footer/>
    </div>    
</template>

<script>
import Footer from '../general/Footer'
import * as firebase from 'firebase/app';
export default {
    name:'Register',
    components:{
        Footer
    },
    data(){
      return{
        course_price_list:{select:'0',webdev01:'1499',sheets01:'499',gamedev01:'1499',cpp01:'999',python01:'999'},
        course_title_list:{select:'-',webdev01:'Web-Development',sheets01:'Sheets/Excel',gamedev01:'Game-Development',cpp01:'C++-Programming',python01:'Python-Programming'},
        error:false,
        
        error_text:'',
        course_id:this.$route.params.id,
        enable_proceed_pay:false,
        first_name:'',
        last_name:'',
        state:'',
        city:'',
        gender:'',
        other_text:'',
        grade:'',
        email:'',
        conf_email:'',
        ph_no:'',
        amt_payable:'',
        agreed:false,
        reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      }
    },created(){
      this.amt_payable=this.course_price_list[this.$route.params.id]
      
    },
    watch:{
      '$route'(to){
          this.course_id = to.params.id
      },
      
    },
   methods:{
     onChangeCourse(eve){
       this.amt_payable=this.course_price_list[eve.target.value]
     },
     gototerms(){
            this.$router.push('/Terms').catch(err => {console.log(err);console.clear();})
        this.menu_drop_active=false
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        },
        
     registerData(){
       this.error_text='' 
      this.error=false
       if(this.first_name==''||this.gender==''||this.grade==''||this.course_id=='select'||this.email==''||this.conf_email==''||this.ph_no==''){
            this.error_text='Form incomplete!' 
            this.error=true
            console.log('form incomplete')
         
       }else if(this.grade=='other' && this.other_text==''){
          this.error_text='Mention your qualification!' 
            this.error=true
            console.log('form incomplete')
       }
       else if(this.email!=this.conf_email){
         this.error_text='Emails do not match' 
         this.error=true
          console.log('Emails dont match')
       }
        else if((this.email == "")? "" : (this.reg.test(this.email)) ? false : true){
          this.error_text='Email invalid!' 
          this.error=true
          }
      else if(this.agreed==false){
         this.error_text='Agree to terms and conditions.' 
         this.error=true
         console.log('did not agree')
       }else if(this.ph_no.length<10){
          this.error_text='Invalid mobile number.' 
         this.error=true
         console.log('Invalid mobile.')
       }else{
         
          var _finalData={
           name:this.first_name+'_'+this.last_name,
           email:this.email,
           gender:this.gender,
           state:this.state,
           city:this.city,
            grade:this.grade,
            other_qual:this.other_text,
            ph_no:this.ph_no,
            course_opt:this.course_title_list[this.course_id],
            amt_to_pay:this.amt_payable+'_'+this.course_id
          };

          var data_codegill_yeet = firebase.firestore();
          data_codegill_yeet.collection("central").doc(_finalData.name).get().then((doc)=>{
          if(doc.exists){
                 var courses_already = doc.data().cg_course_opt;
                 if(courses_already.includes(_finalData.course_opt)){
                  this.error_text='You have already registered for the course. If you have not paid, Proceed to pay. Else ignore.' 
                  this.error=true
                  this.enable_proceed_pay=true
                  if(_finalData.course_opt == 'Web-Development'){
                                        window.location.href = 'https://imjo.in/HSXRqr'
                                        }
                                      if(_finalData.course_opt == 'Game-Development'){
                                        window.location.href = 'https://imjo.in/qcNAUj'
                                          }
                                      if(_finalData.course_opt == 'C++-Programming'){
                                       window.location.href = 'https://imjo.in/HH7nnu'
                                          }
                                      if(_finalData.course_opt == 'Python-Programming'){
                                        window.location.href = 'https://imjo.in/9gBqdh'
                                          }
                                      // if(_finalData.course_opt == 'Sheets/Excel'){
                                      //   window.location.href = 'https://imjo.in/9myAF6'
                                      //     }
                  console.log("You have already registered for the course")
                 }else{
                   this.enable_proceed_pay=false
                   data_codegill_yeet.collection("central").doc(_finalData.name).update({
                                    cg_course_opt: firebase.firestore.FieldValue.arrayUnion(_finalData.course_opt),
                                    cg_price_to_pay:firebase.firestore.FieldValue.arrayUnion(_finalData.amt_to_pay)
                                    }).then(()=> {
                                     if(_finalData.course_opt == 'Web-Development'){
                                       window.location.href = 'https://imjo.in/HSXRqr'
                                        }
                                      if(_finalData.course_opt == 'Game-Development'){
                                       window.location.href = 'https://imjo.in/qcNAUj'
                                          }
                                      if(_finalData.course_opt == 'C++-Programming'){
                                        window.location.href = 'https://imjo.in/HH7nnu'
                                          }
                                      if(_finalData.course_opt == 'Python-Programming'){
                                        window.location.href = 'https://imjo.in/9gBqdh'
                                          }
                                      // if(_finalData.course_opt == 'Sheets/Excel'){
                                      //   window.location.href = 'https://imjo.in/9myAF6'
                                      //     }
                                      })
                                    .catch((error)=>{
                                        console.log("Error getting documents: ", error);
                                    });  
                 }
                }else{
                  
                  data_codegill_yeet.collection("central").doc(_finalData.name).set({
                                cg_name:_finalData.name,
                                cg_email:_finalData.email,
                                cg_phone:_finalData.ph_no,
                                cg_state:_finalData.state,
                                cg_city:_finalData.city,
                                cg_gender:_finalData.gender,
                                cg_grade:_finalData.grade,
                                cg_other_qual:_finalData.other_qual,
                                cg_course_opt:[_finalData.course_opt],
                                cg_price_to_pay:[_finalData.amt_to_pay],
                                cg_pay_status:''
                                 })
                                .then(()=> {
                                     if(_finalData.course_opt == 'Web-Development'){
                                        window.location.href = 'https://imjo.in/HSXRqr'
                                        }
                                      if(_finalData.course_opt == 'Game-Development'){
                                        window.location.href = 'https://imjo.in/qcNAUj'
                                          }
                                      if(_finalData.course_opt == 'C++-Programming'){
                                        window.location.href = 'https://imjo.in/HH7nnu'
                                          }
                                      if(_finalData.course_opt == 'Python-Programming'){
                                        window.location.href = 'https://imjo.in/9gBqdh'
                                          }
                                      // if(_finalData.course_opt == 'Sheets/Excel'){
                                      //   window.location.href = 'https://imjo.in/9myAF6'
                                      //     }
                                      })
                                .catch(function(error) {
                                    console.error("Error adding document: ", error);
                                    });
                
                }
              })
          
          /*,webdev01:'Web-Development',
          sheets01:'Sheets/Excel',
          gamedev01:'Game-Development',
          cpp01:'C++-Programming',
          python01:'Python-Programming'*/
          
        
       }
       
     }
   }
}
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap');
     body{
    background-color: #ffffff;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
  }

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
}
#paybutn{
  background-color: rgb(22, 141, 22);
}
#termi{
  color: rgb(71, 139, 228);
  cursor: pointer;
  text-decoration: underline;
}
#taxtext{
  font-size: 0.8em;
}

#error{
  color: rgb(251, 47, 47);
  font-size: 0.8em;
  text-align: center;
  margin:5px;
}
body{
  background: #7e70d4;
  padding: 0 10px;
  
}
.wrapper{

  max-width: 500px;
  width: 100%;
  background: #fff;
  margin: 50px auto;
  margin-top: 6rem;
  box-shadow: 2px 2px 3px rgba(0,0,0,0.140);
  padding: 30px;
  border-radius: 1rem;
}
.pay{
  width: 100%;
  border: 2px dashed rgb(0, 184, 0);
  padding:1.3rem;
  color: #403679;
}

.wrapper .title{
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #7e70d4;
  text-align: center;
}

.wrapper .form{
  width: 100%;
}

.wrapper .form .inputfield{
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.wrapper .form .inputfield label{
   width: 200px;
   color: #757575;
   margin-right: 10px;
  font-size: 14px;
}

.wrapper .form .inputfield .input,
.wrapper .form .inputfield .textarea{
  width: 100%;
  outline: none;
  border: 1px solid #d5dbd9;
  font-size: 15px;
  padding: 8px 10px;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.wrapper .form .inputfield .textarea{
  width: 100%;
  height: 125px;
  resize: none;
}

.wrapper .form .inputfield .custom_select{
  /* position: relative; */
  width: 100%;
  height: 37px;
}



.wrapper .form .inputfield .custom_select select{
  -webkit-appearance: none;
  -moz-appearance:   none;
  appearance:        none;
  outline: none;
  width: 100%;
  height: 100%;
  border: 0px;
  padding: 8px 10px;
  font-size: 15px;
  border: 1px solid #d5dbd9;
  border-radius: 3px;
}


.wrapper .form .inputfield .input:focus,
.wrapper .form .inputfield .textarea:focus,
.wrapper .form .inputfield .custom_select select:focus{
  border: 1px solid #7e70d4;
}

.wrapper .form .inputfield p{
   font-size: 14px;
   color: #757575;
}
.wrapper .form .inputfield .check{
  width: 15px;
  height: 15px;
  position: relative;
  display: block;
  cursor: pointer;
}
.wrapper .form .inputfield .check input[type="checkbox"]{
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.wrapper .form .inputfield .check .checkmark{
  width: 15px;
  height: 15px;
  border: 1px solid #7e70d4;
  display: block;
  position: relative;
}
.wrapper .form .inputfield .check .checkmark:before{
  content: "";
  position: absolute;
  top: 1px;
  left: 2px;
  width: 5px;
  height: 2px;
  border: 2px solid;
  border-color: transparent transparent #fff #fff;
  transform: rotate(-45deg);
  display: none;
}
.wrapper .form .inputfield .check input[type="checkbox"]:checked ~ .checkmark{
  background: #7e70d4;
}

.wrapper .form .inputfield .check input[type="checkbox"]:checked ~ .checkmark:before{
  display: block;
}

.wrapper .form .inputfield .btn{
  width: 100%;
   padding: 8px 10px;
  font-size: 15px; 
  border: 0px;
  background:  #7e70d4;
  color: #fff;
  cursor: pointer;
  border-radius: 3px;
  outline: none;
}

.wrapper .form .inputfield .btn:hover{
  background: #7e70d4;
}

.wrapper .form .inputfield:last-child{
  margin-bottom: 0;
}

@media (max-width:420px) {
  .wrapper .form .inputfield{
    flex-direction: column;
    align-items: flex-start;
  }
  .wrapper .form .inputfield label{
    margin-bottom: 5px;
  }
  .wrapper .form .inputfield.terms{
    flex-direction: row;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


</style>